import { ISubscription, EventTypes } from 'redux/reducers/subscriptions';
import { EntityTypes } from 'context/entityContext';

export const playListingPriorityEventTypes: EventTypes[] = [
  'priority_playlist_add',
  'priority_playlist_removal',
];

export const playListingEventTypes: EventTypes[] = [
  'playlist_add',
  'playlist_removal',
  'playlist_move_up',
  'playlist_new_peak',
];

export const chartsEventTypes: EventTypes[] = [
  'chart_add',
  'chart_removal',
  'chart_move_up',
  'chart_move_down',
  'chart_new_peak',
];

export default function createNewSubscription(
  entityId: string,
  entityType: EntityTypes = 'artist'
): ISubscription {
  const subscription: ISubscription = {
    entityId,
    entityType,
    eventChannels: [],
    regionId: {},
  };

  return subscription;
}
